<app-base-toast> </app-base-toast>
<app-base-spinner> </app-base-spinner>
<!-- <router-outlet *ngIf="modulePermission$ | async"></router-outlet> -->
<!-- //TODO: PERMISSION-->
<router-outlet></router-outlet>
